import semver from 'semver';

function normalizeVersion(version) {
  return (version || '').replace(/^(\d+)\.(\d+)$/, '$1.$2.0');
}

export function isOsUpgradeAvailable(osVersion, maximumOsVersion) {
  osVersion = normalizeVersion(osVersion);
  const currentOsVersion = normalizeVersion(maximumOsVersion);

  if (semver.valid(osVersion) && semver.valid(currentOsVersion)) {
    return semver.lt(osVersion, currentOsVersion);
  }

  return osVersion !== currentOsVersion;
}

export function isAppUpgradeAvailable(appVersion, currentAppVersion) {
  const normalizedAppVersion = normalizeVersion(appVersion);
  const normalizedCurrentAppVersion = normalizeVersion(currentAppVersion);

  return Boolean(
    semver.valid(normalizedAppVersion) &&
      semver.valid(normalizedCurrentAppVersion) &&
      semver.lt(normalizedAppVersion, normalizedCurrentAppVersion),
  );
}

export function isUpgradeRequired(appVersion, floorVersion) {
  const normalizedAppVersion = normalizeVersion(appVersion);
  const normalizedFloorVersion = normalizeVersion(floorVersion);

  if (semver.valid(normalizedAppVersion) && semver.valid(normalizedFloorVersion)) {
    return semver.lt(normalizedAppVersion, normalizedFloorVersion);
  }

  return false;
}
